import { defineMessages } from 'react-intl'

const baseId = 'infinite_scroller'

export default defineMessages({
  empty: {
    id: `${baseId}.empty`,
    defaultMessage: 'No results',
  },
})
